import { useRef, useCallback } from "react";

export function useSubmitOnce(fn, delay = 1500) {
  const locked = useRef(false);
  return useCallback((...args) => {
    if (locked.current) return;
    locked.current = true;
    fn(...args);
    setTimeout(() => { locked.current = false; }, delay);
  }, [fn, delay]);
}
